import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, Typography, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatCurrency } from '@omega-energia/utilities';
import { BeneficiosMGMTableRowStyles } from '../BeneficiosMGM.style';

const useRowStyles = makeStyles({
  ...BeneficiosMGMTableRowStyles,
  tableCellTextEllipsis: {
    maxWidth: '150px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#00000099',
  },
});

export function BeneficiosMGMTableRow({ dataMGM }) {
  const classes = useRowStyles();

  const renderCellWithTooltip = content => (
    <Tooltip title={content || ''} placement="top">
      <Typography className={classes.tableCellTextEllipsis}>{content || '-'}</Typography>
    </Tooltip>
  );

  return (
    <TableRow>
      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.crmOpportunityId)}</TableCell>

      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.indicatedOrigin)}</TableCell>

      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.indicatedCustomer)}</TableCell>

      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.indicatedPaymentStatus)}</TableCell>

      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.indicatedReason)}</TableCell>

      <TableCell className={classes.tableCell}>
        {renderCellWithTooltip(dataMGM?.indicatedAmount ? formatCurrency(dataMGM?.indicatedAmount) : '-')}
      </TableCell>

      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.indicatorCustomer)}</TableCell>

      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.indicatorPaymentStatus)}</TableCell>

      <TableCell className={classes.tableCell}>{renderCellWithTooltip(dataMGM?.indicatorReason)}</TableCell>

      <TableCell className={classes.tableCell}>
        {renderCellWithTooltip(dataMGM?.indicatorAmount ? formatCurrency(dataMGM?.indicatorAmount) : '-')}
      </TableCell>
    </TableRow>
  );
}

BeneficiosMGMTableRow.propTypes = {
  dataMGM: PropTypes.shape({
    crmOpportunityId: PropTypes.string,
    indicatedCustomer: PropTypes.string,
    indicatorCustomer: PropTypes.string,
    indicatedPaymentStatus: PropTypes.string,
    indicatorPaymentStatus: PropTypes.string,
    indicatedAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    indicatorAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    indicatedOrigin: PropTypes.string,
    indicatorReason: PropTypes.string,
    indicatedReason: PropTypes.string,
  }).isRequired,
};
